import { getCsrfValue } from "~/common/utils/ApiHelper";
import { resolveApiUrl } from "~/utils/url/urlResolver";
import type {
  ConfiguratorV2InitRequest,
  ConfiguratorV2InitResponse,
  ConfiguratorV2LoadRequest,
  ConfiguratorV2SaveRequest,
  ConfiguratorV2SaveResponse,
  ConfiguratorV2StepResetRequest,
  ConfiguratorV2UpdateRequest,
  ConfiguratorV2UpdateResponse,
} from "./configuratorV2Api.types";

const postConfiguratorV2 = async <TResponse>(path: string, body: unknown, operation: string): Promise<TResponse> => {
  const response = await fetch(resolveApiUrl(path), {
    body: JSON.stringify(body),
    credentials: "same-origin",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      CSRFToken: getCsrfValue(),
    },
    method: "POST",
  });

  if (!response.ok) {
    throw new Error(`${operation} failed with status ${response.status}.`);
  }

  return response.json() as Promise<TResponse>;
};

export const initializeConfiguratorV2 = (request: ConfiguratorV2InitRequest) =>
  postConfiguratorV2<ConfiguratorV2InitResponse>("/cpq/v2/init", request, "Configurator initialization");

export const updateConfiguratorV2 = (request: ConfiguratorV2UpdateRequest) =>
  postConfiguratorV2<ConfiguratorV2UpdateResponse>("/cpq/v2/update", request, "Configurator update");

export const resetConfiguratorV2Step = (request: ConfiguratorV2StepResetRequest) =>
  postConfiguratorV2<ConfiguratorV2UpdateResponse>("/cpq/v2/reset-step", request, "Configurator Step reset");

export const saveConfiguratorV2 = (request: ConfiguratorV2SaveRequest) =>
  postConfiguratorV2<ConfiguratorV2SaveResponse>("/cpq/v2/save", request, "Saving the configuration");

export const loadConfiguratorV2 = (request: ConfiguratorV2LoadRequest) =>
  postConfiguratorV2<ConfiguratorV2InitResponse>("/cpq/v2/load", request, "Loading the configuration");
